import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import { solarizedlight } from "react-syntax-highlighter/dist/esm/styles/prism";

class MarkdownCodeBlock extends PureComponent {
  static propTypes = {
    value: PropTypes.string.isRequired,
    language: PropTypes.string
  };

  static defaultProps = {
    language: "python"
  };

  render() {
    const { language, value } = this.props;
    return (
      <SyntaxHighlighter language={language} style={solarizedlight}>
        {value}
      </SyntaxHighlighter>
    );
  }
}

export default MarkdownCodeBlock;
